<template>
  <el-tag
    :type="getColorType(avgValue)"
    :class="`mx-0 ${my} px-4 text-center`"
    effect="dark"
    style="font-size: 13px; width: 100%"
  >
    <strong>{{ avgValue }} {{ tagLabel }}</strong>
  </el-tag>
</template>
<script>
export default {
  name: 'tag-legend',
  props: {
    avgValue: {
      type: String | Number,
    },
    tagType: {
      type: String,
      default: null,
    },
    tagLabel: {
      type: String,
      default: '(%)',
    },
    my: {
      type: String,
      default: 'my-2',
    },
  },
  methods: {
    getColorType(percentage) {
      if (this.tagType) return this.tagType;
      if (percentage < 90) {
        return 'danger';
      } else if (percentage >= 90 && percentage <= 95) {
        return 'warning';
      } else {
        return 'info';
      }
    },
  },
};
</script>
